import React from "react";
import { Image, Modal } from "react-bootstrap";
import "./dialogModal.css";
import MainButton from "../buttons/main_button/MainButton";
import iconAlert from '../../resources/images/ic-alert-modal.svg';
import iconError from '../../resources/images/ic-error-modal.svg';
import iconCamera from '../../resources/images/ic-camera-modal.svg';
import iconAlertRed from '../../resources/images/alert-icons/alert-icon-12.svg';

const DialogModal = ({ isVisible, title, principalMessage, secondaryMessage, type, buttons, onClose, classModal }) => {
    if (!isVisible) return null;
    const iconType = {
        'warningRed': <Image style={{ width: '22px', height: '22px' }} src={iconAlertRed} />,
        'warning': <Image src={iconAlert} />,
        'error': <Image src={iconError} />,
        'camera': <Image style={{ width: '36px', height: '36px'}} src={iconCamera} />
    }
    return (
        <Modal
            show={isVisible}
            onHide={onClose}
            className={classModal ? classModal : 'dialog-modal'}
        >
            <Modal.Header closeButton>
                <div className={'container-title-modal'}>
                    <span>
                        {iconType[type] || iconType['warning']}
                    </span>
                    <Modal.Title>{title}</Modal.Title>
                </div>
            </Modal.Header>
            <Modal.Body className="p-4">
                {principalMessage && principalMessage.map((msg, index) => <p key={index} className="caption">{msg}</p>)}
                {secondaryMessage && secondaryMessage.map((msg, index) => <div key={index}>{msg}</div>)}
            </Modal.Body>
            <Modal.Footer>
                {buttons || <MainButton onClick={onClose} text="Cerrar" />}
            </Modal.Footer>
        </Modal>
    );
};

export default DialogModal;
